import { render, staticRenderFns } from "./chart-of-account.vue?vue&type=template&id=af5406fc"
import script from "./chart-of-account.vue?vue&type=script&lang=js"
export * from "./chart-of-account.vue?vue&type=script&lang=js"
import style0 from "./chart-of-account.vue?vue&type=style&index=0&id=af5406fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports